import { atom } from 'recoil'
import { IProjectType } from './projectTypes.types'

interface IProjectTypesAtom {
  items: IProjectType[]
}

const projectTypesAtom = atom<IProjectTypesAtom>({
  key: 'project-types',
  default: { items: [] },
})
export default projectTypesAtom
